import { useEffect, useState } from "react";

// A phone-width window, or a touch screen of any width (the tablet kiosk is
// 768 px or wider). On these the form gets 16 px text (iOS zooms into smaller
// fields) and 44 px targets; a mouse keeps the compact desktop sizes.
const TOUCH_QUERY = "(max-width: 767.98px), (pointer: coarse)";

function matchesTouch(): boolean {
  return typeof window.matchMedia === "function" && window.matchMedia(TOUCH_QUERY).matches;
}

export default function useIsTouchScreen(): boolean {
  const [isTouch, setIsTouch] = useState(matchesTouch);

  useEffect(() => {
    if (typeof window.matchMedia !== "function") return undefined;
    const query = window.matchMedia(TOUCH_QUERY);
    const onChange = () => setIsTouch(query.matches);
    query.addEventListener("change", onChange);
    return () => query.removeEventListener("change", onChange);
  }, []);

  return isTouch;
}
